module.exports = __webpack_public_path__ + "static/media/GH.d61f9141.png";